import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CategoryDto } from '@aoe/client';
import { Store } from '@ngrx/store';
import * as _ from 'lodash-es';
import { categoriesActions } from 'src/app/core/store/admin/categories-event/categories-event.actions';

@Component({
  selector: 'aoe-edit-category-dialog',
  templateUrl: './edit-category-dialog.component.html',
  styleUrls: ['./edit-category-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule, ReactiveFormsModule, MatSelectModule, MatFormFieldModule, MatInputModule, MatAnchor, MatButtonModule]
})
export class EditCategoryDIalogComponent implements OnInit {

  public editCategoryFG!: FormGroup;
  public years!: number[];

  private readonly nbValues = new Date().getFullYear() + 1 - 1900;

  constructor(
    private readonly fb: FormBuilder,
    private readonly store: Store,
    @Inject(MAT_DIALOG_DATA) public data: { category?: CategoryDto | null, eventId: string }
  ) {
    let i = 1900;
    this.years = Array.from(Array(this.nbValues), () => i++);
  }

  ngOnInit(): void {
    this.editCategoryFG = this.fb.group({
      shortLabel: new FormControl(this.data.category?.code, [Validators.required, Validators.maxLength(10)]),
      longLabel: new FormControl(this.data.category?.label, [Validators.required, Validators.maxLength(100)]),
      startYear: new FormControl(this.data.category?.years.start, [Validators.required]),
      endYear: new FormControl(this.data.category?.years.end, [Validators.required]),
    });
  }

  get startYearValue(): number {
    return this.editCategoryFG.controls['startYear'].value;
  }

  get endYearValue(): number {
    return this.editCategoryFG.controls['endYear'].value;
  }


  submit(): void {
    if (this.editCategoryFG.valid && this.data.category?.id) {
      this.store.dispatch(categoriesActions.updateCatetogyEvent({ payload: this.editCategoryFG.value, categoryId: this.data.category.id, eventId: this.data.eventId }));
    } else {
      this.store.dispatch(categoriesActions.createCatetogyEvent({
        eventId: this.data.eventId,
        payload: this.editCategoryFG.value
      }))
    }

  }

  public numberCharInput(formControl: string): number {
    return this.editCategoryFG.controls[formControl].value?.length;
  }

  public getError(formControl: string): ValidationErrors | null {
    return this.editCategoryFG.controls[formControl].errors;
  }

  public displayError(formControl: string): boolean {
    return (this.editCategoryFG.controls[formControl].status === 'INVALID') && this.editCategoryFG.controls[formControl].touched;
  }

  public isInputValid(formControl: string): boolean {
    return _.isNil(this.editCategoryFG.controls[formControl].errors);
  }

}
